__turbopack_context__.v({
  "e2eeRow": "Home-module__g21JLG__e2eeRow",
  "fadeIn": "Home-module__g21JLG__fadeIn",
  "lk-button": "Home-module__g21JLG__lk-button",
  "logoBadge": "Home-module__g21JLG__logoBadge",
  "main": "Home-module__g21JLG__main",
  "passphraseRow": "Home-module__g21JLG__passphraseRow",
  "slideDown": "Home-module__g21JLG__slideDown",
  "tabContainer": "Home-module__g21JLG__tabContainer",
  "tabContent": "Home-module__g21JLG__tabContent",
  "tabSelect": "Home-module__g21JLG__tabSelect",
});
